import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';
// import tokenApi from './tokenApi';

const resultInstance = axios.create({
    baseURL: config.api,
    headers: {
        'Content-Type': 'application/json'
    }
});


class ResultApi {
    static ResultGet() {
        const token=tokenApi.GetToken();
        return resultInstance.get("/student/result/" + token.student["_id"])
            .then(
                function (res) {
                    // console.log(res.data);
                    return res.data;
            })
            .catch(function (error){
                throw(error);
            })
    }

    static resultDreamSearch(input) {
        // const token=tokenApi.GetToken();
        return resultInstance.get("/occupation?search=" + input)
            .then(
                function (res) {
                    // console.log(res.data);
                    return res.data;
            })
            .catch(function (error){
                throw(error);
            })
    }

    static resultDreamDetailGet(input) {
        // const token=tokenApi.GetToken();
        // console.log(input)
        return resultInstance.get("/occupation/" + input)
            .then(
                function (res) {
                    // console.log(res.data);
                    return res.data;
            })
            .catch(function (error){
                throw(error);
            })
    }

    static resultSuggestDetailGet(input) {
        // const token=tokenApi.GetToken();
        // console.log(input)
        return resultInstance.post("/occupation/recommend",{
            ranking:  input
        })
            .then(
                function (res) {
                    // console.log(res.data);
                    return res.data;
            })
            .catch(function (error){
                throw(error);
            })
    }

    static mainpageJobGet(){
        return resultInstance.get("/occupation")
        .then(
            function (res) {
                // console.log(res.data);
                return res.data;
        })
        .catch(function (error){
            throw(error);
        })
    }

    static getStudentReport() {
        const token=tokenApi.GetToken();
        return resultInstance.get("/student/report/" + token.student["_id"], {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          responseType: 'arraybuffer'
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                throw(error);
            });
    }

    static getAverageData() {
        return resultInstance.get("/student/getAverageScore")
        .then(
            function (res) {
                return res.data;
        })
        .catch(function (error){
            throw(error);
        })
    }

    static getReportEmail(payload) {
      const token=tokenApi.GetToken();
      return resultInstance.post("/student/report/" + token.student["_id"], payload)
      .then(
          function (res) {
              return res.data;
      })
      .catch(function (error){
          throw(error);
      })
    }
}

export default ResultApi;